import { render, staticRenderFns } from "./TransactionCategoryCreate.vue?vue&type=template&id=538b5d82"
import script from "../../../controllers/custom/transaction_category/transaction-category-create.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/transaction_category/transaction-category-create.js?vue&type=script&lang=js&external"
import style0 from "./TransactionCategoryCreate.vue?vue&type=style&index=0&id=538b5d82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports